import React, { Component } from 'react';

import { Form, Field } from 'react-final-form';
import NonValidatedField from '../NonValidatedField/NonValidatedField';
import ValidatedField from '../ValidatedField/ValidatedField';
import ValidatedCheckbox from '../ValidatedCheckbox/ValidatedCheckbox';
import AutoCompleteField from '../AutoCompleteField/AutoCompleteField';
import Signature from '../Signature/Signature';
import FileUpload from '../FileUpload/FileUpload';

const Step1 = (props) => {
    return (
        <div>
            <h2>בדיקת התאמה ביטחונית - עלון לנבדק</h2>

            {/* <br/><br/> */}
            <h4>כללי</h4>

            אתה משמש או מיועד לשמש בתפקיד המחייב סיווג ביטחוני. 
            
            מכח סעיף 7(ב()3) וסעיף 15 לחוק שירות הביטחון הכללי, התשס"ב-2002 (להלן: החוק) התקנות והכללים שמכוחו, שירות הביטחון הכללי הוא הגורם המוסמך במדינת ישראל לקבוע התאמה ביטחונית של אדם לתפקיד או למשרה שסווגו בסיווג ביטחוני.

            בדיקת ההתאמה הביטחונית מתבצעת לקראת שירות צבאי ובמהלכו (כולל שירות מילואים), לפני קבלה לתפקיד ו/או משרה מסווגים, לפני מעבר לתפקיד ו/או משרה בעלי סיווג ביטחוני גבוה יותר וכן, במסגרת בדיקות ביטחון חוזרות כל עוד הנך מוצב בתפקיד מסווג.  

            <br/><br/>
            <h4>תכלית הבדיקה</h4>

            תכלית בדיקת ההתאמה הביטחונית היא להבטיח שבתפקידים ובמשרות שהוגדרו כמסווגים, יועסקו אנשים המתאימים ביטחונית וזאת על מנת להגן על סודות המדינה, אישים ומתקנים מאובטחים.   

            <br/><br/>
            <h4>מי מבצע את הבדיקה</h4>

            בדיקת ההתאמה הביטחונית  מונחית ו/או מבוצעת על-ידי שירות הביטחון הכללי.   
            אולם, חלקים מסוימים של הבדיקה, כמו התחקור הביטחוני (ראיון) והליכים נוספים יבוצעו לרוב על-ידי הגוף אליו אתה מועמד או מועסק בו. פעולות אלו ייעשו בכפוף ובהתאם  להנחיות שרות הביטחון הכללי.  

            <br/><br/>
            <h4>הליכי בדיקת ההתאמה הביטחונית</h4>

            הליך בדיקת ההתאמה הביטחונית עשוי לכלול מרכיבים שונים, כגון: מילוי שאלונים, תחקור ביטחוני, בדיקה רפואית, אבחון פסיכולוגי, בדיקות מהימנות, בדיקות פוליגרף, עיון במאגרי מידע של גופים ציבוריים ופעולות נוספות, דוגמת פנייה לאנשים המכירים אותך מהעבר ו/או בהווה. עם זאת, מרכיבי בדיקת ההתאמה הביטחונית משתנים מבדיקה לבדיקה בהתאם לצורך ולשיקול דעתם של בודקי ההתאמה הביטחונית.   

            בנוסף, יתכן כי במסגרת הליך בדיקת ההתאמה הביטחונית שלך, בני משפחתך מדרגה ראשונה יידרשו לעבור בעצמם בדיקות שונות, לרבות תחקור ביטחוני ובדיקת פוליגרף לצורך קביעת התאמתך הביטחונית.  

            במסגרת הליך ההתאמה הביטחונית תידרש לחתום על הצהרות שונות, בהן ויתור על סודיות מידע וסודיות רפואית. חתימה על הצהרות והתחייבויות אלו הן תנאי לביצוע הליך ההתאמה ביטחונית, והן תעמודנה בתוקף ממועד חתימתך ולכל אורך התקופה בה תשמש בתפקיד מסווג, לרבות בשירות המילואים.    

            <br/><br/>
            <h4>אמינות הנבדק</h4>

            אמינותך בהליך ההתאמה הביטחונית היא בעלת חשיבות מכרעת. דברי שקר, הסתרת מידע ואף אי-דיוקים משמעותיים, עלולים להביא לקביעת אי התאמתך הביטחונית לתפקיד ו/או למשרה מסווגים אליהם הנך מועמד או מועסק.   
            
            <br/><br/>
            <h4>שיתוף פעולה בהליך ההתאמה הביטחונית</h4>

            ביצוע בדיקת ההתאמה הביטחונית וסיומה בזמן סביר תלויים רבות במידת שיתוף הפעולה מצדך. סירוב לעמוד בכל הכרוך בשלבי הבדיקה השונים, עשוי להביא להפסקת בדיקת ההתאמה הביטחונית ואף להביא להחלטה בדבר אי התאמתך הביטחונית, על רקע זה.  

            <br/><br/>
            <h4>שמירת פרטיות</h4>

            כלל, מידע הנמסר בהליכי ההתאמה הביטחונית ישמש לתכלית זו בלבד.   
            בדיקת ההתאמה הביטחונית מתבצעת תוך הקפדה על כך שהפגיעה בפרטיותו של הנבדק, תהיה במידה הנחוצה באופן סביר ושאינה עולה על הנדרש לצורך קביעת ההתאמה הביטחונית.  

            אולם, במקרים מסוימים, ייתכן שמידע שתמסור בהליכי הבדיקה ויימצא לגביו כי הוא רלוונטי וחיוני לגורמי הגיוס או התעסוקה בתפקיד אליו הנך מועמד ו/או מועסק, יועבר לגורמים אלו בהתאם לשיקול דעת שירות הביטחון הכללי.  

            כמו-כן, ככל שאתה מחזיק בהכשר ביטחוני לגופים אחרים, לרבות בשירות המילואים, ייתכן שמידע חיוני ורלוונטי שיעלה בבדיקתך הנוכחית יועבר לגורמים המופקדים על כוח האדם בגופים אלה.   

            בנוסף לאמור, ייתכן שמידע המצביע על חשד לביצוע עבירות משמעת חמורות או עבירות פליליות חמורות, שיעלה במסגרת בדיקת התאמתך הביטחונית, יועבר לגורמי המשמעת במקום העבודה ו/או לגורמי האכיפה, מקום בו יימצא כי קיים אינטרס  ציבורי המחייב העברת המידע.  

            <br/><br/>
            <h4>אי התאמה ביטחונית</h4>

            ככל שיימצא שאינך מתאים ביטחונית לתפקיד או למשרה אליה הנך מועמד ו/או מועסק, תקבל על כך הודעה מנומקת בכתב. קביעה זו תעמוד בתוקפה לכל היותר לפרק זמן  של חמש שנים.  
            החלטה בדבר אי התאמה ביטחונית לתפקיד אליו הנך מועמד ו/או מועסק עלולה להשליך גם על סיווג ביטחוני במקומות אחרים.  

            <br/><br/>
            <h4>השגה על החלטה בדבר אי התאמה ביטחונית</h4>

            נבדק הרואה עצמו נפגע מהחלטה בדבר אי התאמתו הביטחונית למשרה ו/או לתפקיד שסווגו בסיווג ביטחוני, רשאי להשיג על ההחלטה, תוך פרק הזמן הקבוע לכך בחוק.  

            דרך הגשת ההשגה מפורטת בתקנות שירות הביטחון הכללי (הודעה למעביד בדבר דרישות סיווג בטחוני לעובדיו, הודעה לאדם בדבר אי התאמה ביטחונית וועדת השגה על קביעת אי התאמה ביטחונית) התשס"ג-2003.   
            
            <br/><br/>
            <h4>הגשת תלונה על חריגות שנתקיימו בהליך ההתאמה הביטחונית</h4>

            אם הנך סבור, כי בתהליך הבדיקה שנערכה לך טופלת באופן שאינו עולה בקנה אחד עם האמור לעיל, תוכל למסור את תלונתך למבקר שירות הביטחון הכללי.   
            (מספר פקס 03-7453830 כתובת: תלונות הציבור ת.ד. 17539 תא 61172)   
        <br/>
        <br/>
        <ValidatedCheckbox name="isApproveManual" type="checkbox" tabIndex="0" label="הנני מאשר שקראתי את העלון והבנתי את תוכנו" validated={true} />
    </div>
    );
  };
  
  export default Step1;